import * as React from "react";
import { observer } from "mobx-react";
import { TextField, createStyles, withStyles, Grid, Button, Typography } from '@material-ui/core';
import { config } from 'src/config';
import { authStore } from 'src/modules/auth';
import { Loading } from 'src/components/loading';
import { PortalAppBar } from 'src/components/app-bar';
import { Footer } from 'src/components/footer';

const styles = createStyles({
    root: {
        width: "100%",
        height: "100%",
        margin: "0 auto",
        // padding: "1.5rem",
        display: "flex",
        flexDirection: "column",
    },
    rowContainer: {
        width: "100%",
        display: "flex",
        alignContent: "center",
        margin: "0 auto",
        // padding: "3rem",
    },
    columnContainer: {
        width: "100%",
        display: "flex",
        margin: "0 auto",
        // padding: "3rem",
    },
    textField: {
        display: "flex",
        paddingRight: "24px",
    },
    roleSelect: {
        minWidth: "9rem",
    },
    companySelect: {
        minWidth: "16.5rem",
    },
    appRoleSelect: {
        minWidth: "16.5rem",
        paddingTop: "1.5rem",
    },
    formContainer: {
        width: "100%",
        padding: "1.5rem",
    },
    submitContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "row-reverse",
    },
    // submitButton: {
    //   backgroundColor: "#2A2A55",
    //   border: "1px solid #2D4D73",
    //   color: "#FAFAFA",
    // },
});

@observer
class PasswordReset extends React.Component<any> {

    public state = {
        password: '',
        passwordConfirm: '',
        loading: true,
        tokenValid: false
    }

    public componentWillMount = async () => {
        const res = await authStore.checkPasswordResetTokenValid(this.props.match.params.token);
        this.setState({ loading: false, tokenValid: res })
    }

    public handleInput = (property: string) => (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        this.state[property] = e.target.value;
    }

    public checkFieldsEqual = () => {
        if (this.state.password === this.state.passwordConfirm) {
            return true;
        }
        return false;
    }

    public submit = async () => {
        await authStore.changePasswordFromToken(this.state.password, this.props.match.params.token);
        this.props.history.push('/');
    }

    public getHelperInfo = () => {
        let str = " ";
        if (!this.checkFieldsEqual()) {

            str += "Passwords must match. "
        }
        if (this.state.password.length < 4) {
            str += "Password must be at least 4 characters"
        }
        return str
    }

    public render() {
        const { classes } = this.props;
        if (this.state.loading) {
            return <Loading />
        }
        if (!this.state.tokenValid) {
            return (
                <div>
                    <PortalAppBar />
                    <div style={{ paddingTop: '10px', paddingLeft: '10px' }}>
                        <Typography variant='body1'>Invalid/Expired Password reset request. Please return to the <a href={config.BASE_URL}>login page</a> to request again.</Typography>
                    </div>
                    <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                        <Footer />
                    </div>
                </div>
            )
        }
        return (
            <div>
                <PortalAppBar />
                <Grid container={true} direction="column">
                    <Grid
                        container={true}
                        direction="row"
                        classes={{ container: classes.rowContainer }}
                        spacing={24}
                    >
                        <Grid item={true} xs={6}>
                            <Typography variant='h4'>Change User Password</Typography>
                            <TextField
                                label="Password"
                                classes={{ root: classes.textField }}
                                value={this.state.password}
                                InputLabelProps={{ shrink: true }}
                                error={!this.checkFieldsEqual() || this.state.password.length < 4}
                                helperText={
                                    this.getHelperInfo()
                                }
                                type="password"
                                required={true}
                                // onChange={this.handleInput("password")}
                                // tslint:disable-next-line: jsx-no-lambda
                                onChange={(e) => this.setState({ password: e.target.value })}
                            />
                        </Grid>
                        <Grid item={true} xs={6} />
                        <Grid item={true} xs={6}>
                            <TextField
                                label="Password Confirm"
                                classes={{ root: classes.textField }}
                                value={this.state.passwordConfirm}
                                InputLabelProps={{ shrink: true }}
                                error={!this.checkFieldsEqual() || this.state.password.length < 4}
                                type="password"
                                helperText={
                                    this.getHelperInfo()
                                }
                                required={true}
                                // tslint:disable-next-line: jsx-no-lambda
                                onChange={(e) => this.setState({ passwordConfirm: e.target.value })}
                            />
                        </Grid>
                        <Grid item={true} xs={6} />
                        <Grid item={true} xs={6}>
                            <Button
                                classes={{ root: classes.submitButton }}
                                onClick={this.submit}
                                disabled={!this.checkFieldsEqual() || this.state.password.length < 4}
                                variant='contained'
                            >
                                Submit
                        </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                    <Footer />
                </div>

            </div>
        )
    }
}

export default withStyles(styles, { withTheme: true })(
    PasswordReset
);



// WEBPACK FOOTER //
// ./src/modules/portal/PasswordReset.tsx